import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as packageSlice from "../../../../redux/slices/packageSlice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import * as templeSlice from "../../../../redux/slices/templeSlice";
import * as priceSlice from "../../../../redux/slices/priceSlice";

const PricingForm = () => {
  const [templeOptions, setTempleOptions] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);

  const [formData, setFormData] = useState({
    room_price_per_day: undefined,
    extra_bed_price_per_day: undefined,
    service_charge_per_day: undefined,
    gst_percentage:undefined,
    vehicle_types: [
      {
        id: 1,
        price_per_km: undefined,
      },
      {
        id: 2,
        price_per_km: undefined,
      },
      {
        id: 3,
        price_per_km: undefined,
      },
    ],
    mini_package_price:undefined,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list, vehicleList } = useSelector((state) => state.templeSlice);
  const { priceData, loading } = useSelector((state) => state.priceSlice);

  useEffect(() => {
    const pData = priceData?.pricing_settings;
    setFormData({
      room_price_per_day: pData?.room_price_per_day || undefined,
      extra_bed_price_per_day: pData?.extra_bed_price_per_day || undefined,
      service_charge_per_day: pData?.service_charge_per_day || undefined,
      gst_percentage: pData?.gst_percentage || undefined,
      vehicle_types: priceData?.vehicle_types || [],
      mini_package_price:pData?.mini_package_price || undefined
    });
  }, [priceData?.vehicle_types,priceData?.pricing_settings]);
// console.log(priceData,"priceData")
// console.log(formData,"priceData2")

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.room_price_per_day) {
      toast("Please enter room price");
      return;
    } if (!formData?.gst_percentage) {
      toast("Please enter gst percentage");
      return;
    }
    if (!formData?.extra_bed_price_per_day) {
      toast("Please enter extra bed price");
      return;
    }
    if (!formData?.service_charge_per_day) {
      toast("Please enter service charge per day");
      return;
    }
    if (!formData?.room_price_per_day) {
      toast("Please enter room price per day");
      return;
    }
    if (!formData?.mini_package_price) {
      toast("Please enter mini package price");
      return;
    }
    await dispatch(priceSlice.updatePackageList(formData));
    dispatch(priceSlice.getPrice());
  };

  useEffect(() => {
    dispatch(priceSlice.getPrice());
    dispatch(templeSlice.getVehicleList());
  }, [dispatch]);

  return (
    <>
      <h5 className="mb-3">Price Module</h5>
      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <>
          {" "}
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="package_name">
                  <Form.Label>
                    Room Price Per Day <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.room_price_per_day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        room_price_per_day: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="number_of_days">
                  <Form.Label>
                    Extra Bed Price Per Day <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.extra_bed_price_per_day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        extra_bed_price_per_day: e.target.value,
                      })
                    }
                    placeholder="Enter Price"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
            <Col md={6}>
                <Form.Group controlId="package_name">
                  <Form.Label>
                    Service Charge Per Day{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.service_charge_per_day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        service_charge_per_day: e.target.value,
                      })
                    }
                    placeholder="Enter Charges"
                  />
                </Form.Group>
              </Col>  
              <Col md={6}>
                <Form.Group controlId="package_name">
                  <Form.Label>
                  GST Percentage
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.gst_percentage}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        gst_percentage: e.target.value,
                      })
                    }
                    placeholder="Enter GST Percentage"
                  />
                </Form.Group>
              </Col>
            </Row> <Row>
            <Col md={6}>
                <Form.Group controlId="package_name">
                  <Form.Label>
                    Mini package price
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={formData?.mini_package_price}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mini_package_price: e.target.value,
                      })
                    }
                    placeholder="Enter mini package price"
                  />
                </Form.Group>
              </Col>  
            </Row>
            {/* Headings for the columns */}
            <Row className="mb-3">
              <Col xs={6}>
                <h6>Vehicle Type</h6>
              </Col>
              <Col xs={6}>
                <h6>Price Per Km</h6>
              </Col>
            </Row>

            {formData?.vehicle_types?.map((v, i) => (
              <>
                <Row key={i} className="mb-3 align-items-center">
                  {/* Vehicle Type */}
                  <Col xs={6}>
                    <Form.Group controlId="type_name">
                      <Form.Control
                        type="text"
                        value={v?.type_name}
                        disabled
                        placeholder="Vehicle Type"
                      />
                    </Form.Group>
                  </Col>

                  {/* Price Per Km */}
                  <Col xs={6}>
                    <Form.Group controlId="price_per_km">
                      <Form.Control
                        type="number"
                        value={v?.price_per_km}
                        onChange={(e) => {
                          const updatedVehicleTypes = [
                            ...formData.vehicle_types,
                          ];
                          updatedVehicleTypes[i] = {
                            ...updatedVehicleTypes[i],
                            price_per_km: parseInt(e.target.value),
                          };
                          setFormData({
                            ...formData,
                            vehicle_types: updatedVehicleTypes,
                          });
                        }}
                        placeholder="Enter Price"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            ))}

            <button type="submit" className="btn_primary text-center">
              Update
            </button>
          </Form>
        </>
      )}
    </>
  );
};

export default PricingForm;
